import { useEffect } from 'react';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import DefaultLayout from '../../../layout/DefaultLayout';
import PurchaseDocumentSection from '../../../components/purchases/PurchaseDocumentSection';
import BasePurchaseForm from '../../../components/purchases/base/BasePurchaseForm';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';

const BasePurchasePage = () => {
  const {
    purchaseSaved,
    purchaseLoaded,
    purchaseSettlementLoaded,
    handlerClearFilteredPurchaseList,
  } = useBasePurchase();

  useEffect(() => {
    handlerClearFilteredPurchaseList();
  }, []);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      {(purchaseSaved || purchaseLoaded || purchaseSettlementLoaded) ? (
        <PurchaseDocumentSection />
      ) : (
        <BasePurchaseForm />
      )}
    </DefaultLayout>
  );
};

export default BasePurchasePage;
